<template>
    <Professions />
  </template>
  
  <script>
  import Professions from '@/components/admin/recommendations/Professions.vue'
  
  export default {
    name: 'AdministrationProfessions',
    components: { Professions }
  }
  </script>
  
  <style scoped>
  
  </style>
  